// extracted by mini-css-extract-plugin
export default {"parameter":"WGCRh","selected":"kAXwE","noPopover":"YRyWQ","name":"BYKPY dPTrR"};